<template>
  <b-modal
    centered
    id="add-material"
    modal-class="overflow-hidden"
    static
    scrollable
    @hidden="onHidden"
    :no-close-on-backdrop="true"
    ignore-enforce-focus-selector="input"
  >
    <template #modal-header="{ close }">
      <h5>Chọn vật tư</h5>
      <b-button size="sm" variant="light" @click="close()"> x </b-button>
    </template>
    <div>
      <div class="form-group">
        <label>Tên vật tư <span style="color: red">*</span></label>
        <Select2 v-model="material" :options="dataMaterial" placeholder="Tên vật tư" />
      </div>
      <div class="form-group">
        <label>Số lượng <span style="color: red">*</span></label>
        <input placeholder="Số lượng" v-model="quantity" />
      </div>
      <div class="form-group">
        <label>Ghi chú</label>
        <input placeholder="Ghi chú" v-model="note" />
      </div>
    </div>
    <template #modal-footer="{ cancel }">
      <b-button size="sm" variant="light" @click="cancel()"> Hủy bỏ </b-button>
      <b-button size="sm" variant="primary" @click="updateStatus"> Xác nhận </b-button>
    </template>
  </b-modal>
</template>

<script>
  export default {
    props: {
      dataMaterial: {
        type: Array,
        default: Array,
      },
    },
    data() {
      return {
        material: '',
        quantity: '',
        note: '',
      }
    },

    methods: {
      async updateStatus() {
        if (this.material === '') this.showFailMx('Vật tư không được để trống')
        else if (this.quantity === '') this.showFailMx('Số lượng không được để trống')
        else {
          const category = this.dataMaterial.find(e => e.id === this.material)
          const data = {
            text: category.text,
            id: this.material,
            quantity: this.quantity,
            note: this.note,
            kind: 'NORMAL',
          }
          this.$emit('updateStatus', data)
        }
      },
      onHidden() {
        this.$emit('onHidden')
      },
    },
  }
</script>

<style scoped></style>
